module.exports = __webpack_public_path__ + "./images/arrow.svg?1fc50cb384cba57a1ab49ac925edd70c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow.svg
// module id = 7
// module chunks = 0